export const REACT_TERMINAL_PAGE = "/webpunch/terminalsetup";

export const REACT_EMPLOYEE_LOGIN_SCREEN = "/webpunch/employeeLogin";

export const REACT_FUNCTION_KEY_SCREEN = "/webpunch/function_key";

export const REACT_ATTESTATION = "/webpunch/attestation";

export const REACT_LABOR_CODE = "/webpunch/labor_code";

export const REACT_GENERAL_QUESTION = "/webpunch/general_question";

export const REACT_FEEDBACK_SCREEN = "/webpunch/feedback_screen";

export const REACT_PUNCH_LOCKOUT = "/webpunch/punch_lockout";

export const ACCRUAL_BALANCE_PAGE = "/webpunch/accrual_balance";

export const PUNCH_INFO_PAGE = "/webpunch/punch_info";

export const LAST_PUNCH_PAGE = "/webpunch/last_punch";

export const ONLINE_SCHEDULE_SELF_SERVICE = "/webpunch/online_schedule";

export const RESET_PASSWORD = "/webpunch/update_password";

export const ERROR_PAGE ='/error';


